import {createSelector} from 'reselect'
import {isLoaded as isEditPanelLoaded} from '../editPanel/selectors'
import {arrayToMap} from '../../../atUtils'
import {UserTeamAssignmentType} from '../constants'
import {getUsers} from '../../../entities/selectors'
import {canAccessAllTeamScope, canAccessManagersScope} from '../../../util/accessRightsUtils'

export const selectTeamAssignmentsPanel = state => state.userManagement.editTeamAssignmentsPanel

export const getUserId = createSelector(
    selectTeamAssignmentsPanel,
    panel => panel.userId
)

export const getPanelUser = createSelector(
    getUserId,
    getUsers,
    (userId, users) => users[userId]
)

export const getPanelUserFirstName = createSelector(
    getPanelUser,
    user => user ? user.firstName : ''
)

export const isPanelOpened = createSelector(
    getUserId,
    userId => userId !== null
)

export const isNeedToLoadData = createSelector(
    isPanelOpened,
    isEditPanelLoaded,
    (opened, loaded) => {
        return (opened === true && (loaded === false))
    }
)

export const isShowCopyContent = createSelector(
    selectTeamAssignmentsPanel,
    panelState => panelState.showCopyContent
)

export const getCopyContentState = createSelector(
    selectTeamAssignmentsPanel,
    panelState => panelState.copyContent
)

export const getCopyUserId = createSelector(
    getCopyContentState,
    copyContent => copyContent.userId
)

export const isCopyLoading = createSelector(
    getCopyContentState,
    copyContent => copyContent.loading
)

const _getSelectorsUsers = createSelector(
    getCopyContentState,
    copyContent => copyContent.usersForSelector
)

export const getSelectorsUsers = createSelector(
    _getSelectorsUsers,
    getUserId,
    (usersForSelector, userToId) => usersForSelector.filter(user => user.id !== userToId
                                                                    && canAccessManagersScope(user) && !canAccessAllTeamScope(user)
                                                                    && user.teamAssignmentType === UserTeamAssignmentType.SELECTED)
)

export const getCopyUserFrom = createSelector(
    getCopyUserId,
    getSelectorsUsers,
    (id, users) => {
        const usersMap = arrayToMap(users)
        return id ? usersMap[id] : null
    }
)

export const getUserFromAssignedUsers = createSelector(
    getCopyContentState,
    copyContent => copyContent.userFromAssignedUsers
)



// WEBPACK FOOTER //
// ./web/js/panels/user/editTeamAssignmentsPanel/selectors.js